import { render } from "./index.vue?vue&type=template&id=3a85b1e4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3a85b1e4&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=3a85b1e4&lang=scss"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a85b1e4"]])

export default __exports__